class e extends HTMLElement {
  constructor() {
    super(), this.button = this.querySelector("button"), this.sectionId = this.getAttribute("data-section-id"), this.innerId = `LoadMore-${this.sectionId}`, this.section = document.getElementById(this.innerId), this.list = this.section.querySelector("[data-load-list]"), this.currentPage = Number(this.list.getAttribute("data-current-page")), this.totalPages = Number(this.list.getAttribute("data-total-pages")) || 1;
  }
  connectedCallback() {
    this.button.addEventListener("click", () => {
      this.currentPage++, this.list.setAttribute("data-current-page", this.currentPage), this.list.querySelectorAll("li").forEach((t) => {
        Number(t.getAttribute("data-page")) <= this.currentPage && t.classList.remove("hidden");
      }), this.currentPage == this.totalPages && this.button.classList.add("hidden");
    });
  }
}
window.customElements.define("simple-load-more", e);
export {
  e as SimpleLoadMore
};
